import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import { asyncRouterHandle } from '@/utils/asyncRouter';
import { fetchMenuList } from '@/api/menu';
var routerList = [];
var _formatRouter = function formatRouter(routes) {
  routes && routes.map(function (item) {
    if ((!item.children || item.children.every(function (ch) {
      return ch.hidden;
    })) && item.name !== '404') {
      routerList.push({
        label: item.meta.title,
        value: item.name
      });
    }
    item.hidden = item.meta.hidden;
    if (item.children && item.children.length > 0) {
      _formatRouter(item.children);
    } else {
      delete item.children;
    }
  });
};
export default {
  namespaced: true,
  state: {
    asyncRouters: [],
    routerList: routerList
  },
  mutations: {
    setRouterList: function setRouterList(state, routerList) {
      state.routerList = routerList;
    },
    // 设置动态路由
    setAsyncRouter: function setAsyncRouter(state, asyncRouters) {
      state.asyncRouters = asyncRouters;
    }
  },
  actions: {
    // 从后台获取动态路由
    SetAsyncRouter: function SetAsyncRouter(_ref) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var commit, asyncRouterRes, asyncRouter;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 1;
              return fetchMenuList();
            case 1:
              asyncRouterRes = _context.sent;
              asyncRouter = asyncRouterRes.data;
              _formatRouter(asyncRouter);
              asyncRouter.push({
                path: '/login/:token',
                component: 'views/login/index.vue',
                hidden: true
              });
              asyncRouter.push({
                path: '/iframe',
                component: 'layout',
                children: [{
                  path: 'go',
                  name: 'iframe',
                  component: 'views/iframe.vue',
                  hidden: true
                }]
              });
              asyncRouter.push({
                path: '/user-business-voucher',
                name: 'userBusinessVoucher',
                component: 'views/transaction/userBusinessVoucher.vue',
                redirect: ''
              });
              asyncRouter.push({
                path: '*',
                redirect: '/404',
                hidden: true
              });
              asyncRouterHandle(asyncRouter);
              commit('setAsyncRouter', asyncRouter);
              commit('setRouterList', routerList);
              return _context.abrupt("return", true);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    // 获取动态路由
    asyncRouters: function asyncRouters(state) {
      return state.asyncRouters;
    },
    routerList: function routerList(state) {
      return state.routerList;
    }
  }
};